<template>
    <div class="px-x-mobil lg:px-x-desktop my-pad-2">
        <h1>İade ve Değişim Şartları</h1> <br>
        <p>Değerli Müşterilerimiz,</p> <br>
        <p>Firmamız, sizlere sunduğu ürünlerde en yüksek kalite ve memnuniyeti sağlama konusunda büyük bir özen
            göstermektedir. Ancak, bazen beklenmedik durumlar oluşabilmekte ve bu durumlarda yanınızda olmaktan
            mutluluk duyarız. İade ve değişim politikamız, satın aldığınız ürünlerle ilgili herhangi bir endişeniz
            olduğunda size rehberlik etmek üzere tasarlanmıştır.</p> <br>
        <ol>
            <li>
                <p><strong>Firmamızdan Kaynaklı Hatalar:</strong>&nbsp;Eğer satın aldığınız ürünler, defolu, dikim
                    hatalı, yanlış ölçülü gibi firmamızdan kaynaklanan bir sorunla size ulaştıysa, bu ürünlerin
                    ücretsiz olarak iade ve değişimi mümkündür. Bu tür durumlarda, müşteri memnuniyeti bizim için en
                    önemli önceliktir. Lütfen, bu tip bir sorunla karşılaştığınızda, ürünü aldığınız tarihten
                    itibaren 15 gün içinde bizimle iletişime geçin.</p>
            </li><br>
            <li>
                <p><strong>Standart Ürünlerde İade ve Değişim:</strong>&nbsp;“Özel dikim olmayan standart ürünler”
                    için, eğer ürünü beğenmediyseniz ya da fikrinizi değiştirdiyseniz, kargo masraflarını karşılamak
                    şartıyla iade veya değişim yapabilirsiniz. Bu tür iadeler için ürünün orijinal paketinde,
                    kullanılmamış ve etiketleri üzerinde olması gerekmektedir.</p>
            </li><br>
            <li>
                <p><strong>Özel Dikim Ürünlerde İade ve Değişim Sınırlamaları:</strong>&nbsp;Özel dikim ürünler
                    için, yukarıda belirtilen firmamızdan kaynaklı hatalar dışında, keyfi nedenlerle iade ve değişim
                    yapılamamaktadır. Bu ürünler, sizin özel talepleriniz doğrultusunda hazırlandığı için, sadece
                    kalite veya üretim hatalarında iade veya değişim kabul edilmektedir.</p>
            </li><br>
        </ol>
        <p>Her zaman daha iyi bir alışveriş deneyimi sunmak için çalışıyoruz ve her türlü soru veya endişenizde size
            yardımcı olmaktan mutluluk duyarız. Satın alma işleminizle ilgili herhangi bir sorunuz olursa, lütfen
            bizimle iletişime geçmekten çekinmeyin.</p>
    </div>
</template>

<script setup>
useHead({
    title: 'İade ve değişim şartları - Beyraha',
})

</script>